<template>
  <v-container fill-height align-center>
    <v-row class="pa-6">
      <v-col cols="12">
        <v-row align="center" justify="center">
          <div v-if="categories.length > 0" :class="`text-xs-center  ${ $vuetify.breakpoint.xs ? 'headline my-3' : $vuetify.breakpoint.sm ? 'display-2 my-3' : 'display-2 mb-4' }`">
            {{ userProfile.userType ? (userProfile.userType.hefe ? $language.registration["Skills you are looking for"] : $language.registration["Skills you offer"]) : $language.registration["Skills"] }}:
          </div>
        </v-row>
      </v-col>

      <v-col cols="12" v-if="$vuetify.breakpoint.mdAndUp">
        <v-row class="ml-10">
          <v-col cols="4" v-for="(category) in categories" class="pa-0" :key="category._key">
            <v-row no-gutters align="center" >
              <v-checkbox class="ma-0 pa-0" hide-details v-model="selectedCategories" :value="category._key"><template v-slot:label>
                  <v-row no-gutters align="center">
                      <v-img :src="require(`@/assets/${category._key}.svg`)" height="24" width="24" contain></v-img>

                      <span class="pl-2 caption">
                        {{$language.settings.Categories[category._key]}}</span>
                  </v-row>

                </template>
              </v-checkbox>
            </v-row>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" v-else>
        <v-row no-gutters>
          <v-col cols="6" v-for="(category) in categories" class="pa-0" :key="category._key">
            <v-row no-gutters align="center" >
              <v-checkbox class="ma-0 pa-0" hide-details v-model="selectedCategories" :value="category._key"><template v-slot:label>
                  <v-row no-gutters align="center">
                      <v-img :src="require(`@/assets/${category._key}.svg`)" height="24" width="24" contain></v-img>

                      <span class="pl-2 caption">
                        {{$language.settings.Categories[category._key]}}</span>
                  </v-row>

                </template>
              </v-checkbox>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-row align="center" justify="center">
          <v-btn text color="primary" @click="selectAll">{{ this.categories.length === this.selectedCategories.length ? 'Clear selection' : 'Select all' }}</v-btn>

        </v-row>
      </v-col>
      <v-col cols="12">
        <v-row align="center" justify="center">
          <v-btn block style="height: 60px;" color="primary" class="px-0 mx-0" @click="setCategory" :disabled="selectedCategories.length === 0">
            {{ $language.registration["Next"] }}
          </v-btn>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
  <!-- <v-layout column fill-height align-space-around justify-center :style="$vuetify.breakpoint.mdAndUp ? 'max-width: 960px; margin-left: calc(50% - 480px)' : ''">
  <v-layout column fill-height justify-center pt-4 mt-4>

    <div v-if="categories.length > 0" :class="`text-xs-center grey--text text--darken-4 ${ $vuetify.breakpoint.xs ? 'headline my-3' : $vuetify.breakpoint.sm ? 'display-2 my-3' : 'display-2 mb-4' }`">
      {{ userProfile.userType ? (userProfile.userType.hefe ? $language.registration["Skills you are looking for"] : $language.registration["Skills you offer"]) : $language.registration["Skills"] }}:
    </div>
    <v-layout row wrap justify-center>
      <v-flex xs12>
        <div v-if="categories.length > 0" :style="`${ $vuetify.breakpoint.xs ? 'max-height: 350px' : $vuetify.breakpoint.sm ? 'max-height: 500px' : 'max-height: 450px' }`" :class="`${ $vuetify.breakpoint.xs ? 'scroll-y headline mb-1' : $vuetify.breakpoint.sm ? 'display-2 mb-1 pl-5' : 'display-2 pl-5 mb-1' }`">
          <v-layout row wrap ml-4>
            <template v-for="(category) in categories">
              <v-flex xs6 :key="category._key">
                <v-checkbox class="ma-0 mb-1 pa-0" hide-details  :label="category._key" v-model="selectedCategories" :value="category._key"></v-checkbox>
              </v-flex>
            </template>
          </v-layout>
        </div>
        <v-flex xs12>
          <div class="text-xs-center mt-0 pt-0">
            <v-btn flat color="primary" @click="selectAll">{{ this.categories.length === this.selectedCategories.length ? 'Clear selection' : 'Select all' }}</v-btn>
          </div>
        </v-flex>

      </v-flex>
      <v-flex style="min-height: 80px; max-height: 80px;">
        <v-btn block style="height: 60px;" color="primary" class="px-0 mx-0" @click="setCategory" :disabled="selectedCategories.length === 0">
          {{ $language.registration["Next"] }}
        </v-btn>
      </v-flex>
    </v-layout>

    <v-layout v-if="categories.length === 0" column fill-height align-center justify-center style="min-height: 400px">
      <v-progress-circular indeterminate color="primary" size="70"></v-progress-circular>
    </v-layout>
    <v-spacer></v-spacer>
  </v-layout>

  <v-snackbar v-model="snackbar" color="error" multi-line>
    Please select at least one category.
    <v-btn flat @click="snackbar = false">
      Close
    </v-btn>
  </v-snackbar>
</v-layout> -->
</template>

<script>
// we use the categories on the settings page, and the ObrJoSearch page
// this.userProfile.categories
import { mapState } from 'vuex'
const fb = require('@/services/firebaseConfig.js')
export default {
  data () {
    return {
      snackbar: false,
      selectedCategories: []
    }
  },
  computed: {
    ...mapState(['userProfile', 'currentUser', 'categories'])
  },
  watch: {
    'userProfile.public.categories': {
      handler: function () {
        if (this.userProfile.public) {
          this.selectedCategories =
            [...(this.userProfile.public.categories || [])] || []
        }
      },

      immediate: true
    }
  },
  methods: {
    selectAll () {
      if (this.categories.length === this.selectedCategories.length) {
        this.selectedCategories = []
      } else {
        let tempCategories = []
        this.categories.forEach(category => {
          tempCategories.push(category._key)
        })
        this.selectedCategories = tempCategories
        // Has to be made this ugly because categories is some weird object instead of a plain array of strings
      }
    },

    async setCategory () {
      if (this.selectedCategories.length > 0) {
        // var sendCategories = {}
        // this.selectedCategories.forEach(item => {
        //   sendCategories[item] = true
        // })
        await fb.database
          .ref(`user/${this.currentUser.uid}/profile/public/categories`)
          .set(this.selectedCategories)
        this.$emit('next')
      } else {
        this.snackbar = true
      }
      // What does this do? Why true and not just empty ? //
      // if (this.selectedCategories === undefined) {       //
      //   this.selectedCategories = true                  //
      // }                                                //
      // ----------------------------------------------//
    }
  }
}
</script>
